import clsx from 'clsx';
import styles from './Count.module.scss';

interface CountProps extends React.HTMLAttributes<HTMLSpanElement> {
  children: React.ReactNode;
}

export const Count: React.FC<CountProps> = ({ className, children, ...props }) => (
  <span className={clsx(styles.count, className)} {...props}>
    {children}
  </span>
);
